import { CreateFamilyAwardSeasonInput, UpdateFamilyAwardSeasonInput, FamilyAwardSeasonView, FamilyAwardEntryView, } from '../../family-awards.js';
import { CursorQuery, Paginated } from '../../common/pagination.js';
export const adminFamilyAwardRoutes = {
    awardSeasons: {
        method: 'GET',
        path: '/admin/family/awards/seasons',
        query: CursorQuery,
        response: Paginated(FamilyAwardSeasonView),
    },
    createAwardSeason: {
        method: 'POST',
        path: '/admin/family/awards/seasons',
        body: CreateFamilyAwardSeasonInput,
        response: FamilyAwardSeasonView,
    },
    updateAwardSeason: {
        method: 'PUT',
        path: '/admin/family/awards/seasons/:seasonId',
        body: UpdateFamilyAwardSeasonInput,
        response: FamilyAwardSeasonView,
    },
    awardEntries: {
        method: 'GET',
        path: '/admin/family/awards/entries',
        query: CursorQuery,
        response: Paginated(FamilyAwardEntryView),
    },
};
//# sourceMappingURL=awards-routes.js.map